import ShipperDetail from "@/classes/bookings/ShipperDetail";
import ConsigneeDetail from "@/classes/bookings/ConsigneeDetail";

export class Booking {

    constructor() {

        this.id = 0;
        this.jobNumber = '';
        this.customer = '';

        this.shipper = new ShipperDetail();
        this.consignee = new ConsigneeDetail();

        this.dimensions = {

            multiLineDims: [],
            totalPieces: '',
            totalWeight: '',
            chargeableWeight: '',
            cubeUnit:'',
            cube: ''
        }

        this.isUpdate = {

            shipper: false,
            consignee: false

        }

        this.unitOfMeasureSwitch = false,
        this.cubeUnitSwitch = false,

        this.files = [];

    }
}
